export default __webpack_public_path__ + "static/media/eye.1bbead94.svg";